import { render } from "./admin-sidebar.vue?vue&type=template&id=3f73b761"
import script from "./admin-sidebar.vue?vue&type=script&lang=js"
export * from "./admin-sidebar.vue?vue&type=script&lang=js"

import "./admin-sidebar.vue?vue&type=style&index=0&id=3f73b761&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__